import { ProductCode } from '@symon-ai/wisepipe-authorize-domain';
import { CircleVisualSubType, GenericVisualSubType, VisualType } from '@symon-ai/wisepipe-base-computation';
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { SubscriptionType } from '@symon-ai/wisepipe-common';
import { ConnectionType } from '@symon-ai/wisepipe-common-connection';
import { BlueprintType, SolutionType } from '@symon-ai/wisepipe-solution-domain';
export var ToolCommandModal;
(function (ToolCommandModal) {
    ToolCommandModal["Predictor"] = "predictor";
    ToolCommandModal["Prepare"] = "prepare";
    ToolCommandModal["Group"] = "group";
    ToolCommandModal["Compare"] = "compare";
    ToolCommandModal["Clean"] = "clean";
    ToolCommandModal["Text"] = "text";
    ToolCommandModal["Date"] = "date";
    ToolCommandModal["Compute"] = "compute";
    ToolCommandModal["Understand"] = "understand";
    ToolCommandModal["Connect"] = "connect";
    ToolCommandModal["Encode"] = "encode";
    ToolCommandModal["SampleData"] = "sampleData";
    ToolCommandModal["Optimize"] = "optimize";
    ToolCommandModal["SPM"] = "spm";
    ToolCommandModal["Incentives"] = "incentives";
    ToolCommandModal["Visualizations"] = "visualizations";
    ToolCommandModal["ReusableLogic"] = "reusableLogic";
})(ToolCommandModal || (ToolCommandModal = {}));
export var BlueprintModelType;
(function (BlueprintModelType) {
    BlueprintModelType["HowTos"] = "blueprintsHowTos";
    BlueprintModelType["Marketplace"] = "blueprintsMarketplace";
    BlueprintModelType["ELT"] = "blueprintsELT";
    BlueprintModelType["RevIntel"] = "blueprintsRevIntel";
    BlueprintModelType["SalesCompensation"] = "blueprintsSalesCompensation";
})(BlueprintModelType || (BlueprintModelType = {}));
export const BlueprintsGroup = {
    [BlueprintModelType.HowTos]: [
        ProductCode.BlueprintFuzzyMatcher,
        ProductCode.BlueprintSmartMatcher,
        ProductCode.BlueprintCombinationMatcher,
        ProductCode.BlueprintForecasting,
        ProductCode.BlueprintHierarchyCreation,
        ProductCode.BlueprintHierarchyValidator
    ],
    [BlueprintModelType.Marketplace]: [ProductCode.AppSalesBenchmarking],
    [BlueprintModelType.ELT]: [
        ProductCode.BlueprintOrderConsolidation,
        ProductCode.BlueprintRosterValidation,
        ProductCode.BlueprintRecordIDAndAdjustment,
        ProductCode.BlueprintIdentifyNewHires,
        ProductCode.BlueprintTrackTerritoryChanges,
        ProductCode.BlueprintTransactionReconciliation,
        ProductCode.BlueprintTransactionValidation,
        ProductCode.BlueprintEntityResolution
    ],
    [BlueprintModelType.RevIntel]: [
        ProductCode.BlueprintOpportunityScores,
        ProductCode.BlueprintDealValueChanges,
        ProductCode.BlueprintDiscountingDiagnostics,
        ProductCode.BlueprintLeadScoring,
        ProductCode.BlueprintCustomerLifetimeValue,
        ProductCode.BlueprintSellerCapacity,
        ProductCode.BlueprintFinancialAdvisorTurnover,
        ProductCode.AppSellerChurn,
        ProductCode.AppSellerPerformance
    ],
    [BlueprintModelType.SalesCompensation]: [
        ProductCode.BlueprintPayoutOutliers,
        ProductCode.BlueprintManualAdjustmentOutliers,
        ProductCode.BlueprintSellerValueOutliers,
        ProductCode.BlueprintASC606Preparation,
        ProductCode.BlueprintASC606Amortization,
        ProductCode.BlueprintTransactionOutliers,
        ProductCode.BlueprintFinancialAdvisorTurnover,
        ProductCode.AppSellerChurn,
        ProductCode.AppSellerPerformance
    ]
};
export const ToolsGroup = {
    [ToolCommandModal.Predictor]: [
        ProductCode.ToolGenderClassifier,
        ProductCode.ToolSmartMatcher,
        ProductCode.ToolClassifier,
        ProductCode.ToolRegressor,
        ProductCode.ToolForecast,
        ProductCode.ToolPredictor
    ],
    [ToolCommandModal.Prepare]: [
        ProductCode.ToolCombinationMatcher,
        ProductCode.ToolFuzzyMatcher,
        ProductCode.ToolJoin,
        ProductCode.ToolRecordID,
        ProductCode.ToolRepeat,
        ProductCode.ToolReshape,
        ProductCode.ToolSnapshot,
        ProductCode.ToolSplit,
        ProductCode.ToolTextGradeLevel,
        ProductCode.ToolUnion,
        ProductCode.ToolMultiUnion,
        ProductCode.ToolHierarchy,
        ProductCode.ToolHierarchyV2,
        ProductCode.ToolLookup
    ],
    [ToolCommandModal.Group]: [
        ProductCode.ToolAggregate,
        ProductCode.ToolAggregateV2,
        ProductCode.ToolBinning,
        ProductCode.ToolPercentile
    ],
    [ToolCommandModal.Compare]: [ProductCode.ToolRank, ProductCode.ToolSort],
    [ToolCommandModal.Clean]: [
        ProductCode.ToolAdapt,
        ProductCode.ToolCase,
        ProductCode.ToolChangeType,
        ProductCode.ToolCleanCharacter,
        ProductCode.ToolConditional,
        ProductCode.ToolUnique,
        ProductCode.ToolDrop,
        ProductCode.ToolFill,
        ProductCode.ToolFilter,
        ProductCode.ToolLimit,
        ProductCode.ToolRemoveOutliers,
        ProductCode.ToolRemoveEmpty,
        ProductCode.ToolRename,
        ProductCode.ToolReorder,
        ProductCode.ToolSelect,
        ProductCode.ToolHierarchyValidator,
        ProductCode.ToolHierarchyValidatorV2
    ],
    [ToolCommandModal.Text]: [
        ProductCode.ToolChangeCase,
        ProductCode.ToolExtract,
        ProductCode.ToolMergeColumns,
        ProductCode.ToolReplace,
        ProductCode.ToolMultiReplace,
        ProductCode.ToolSelectWord,
        ProductCode.ToolTextBetween,
        ProductCode.ToolTextLength,
        ProductCode.ToolTextPart,
        ProductCode.ToolTextSentiment,
        ProductCode.ToolTrim,
        ProductCode.ToolTrimTags,
        ProductCode.ToolTextClassifier,
        ProductCode.ToolWordFrequency
    ],
    [ToolCommandModal.Date]: [
        ProductCode.ToolDateAdd,
        ProductCode.ToolDateDiff,
        ProductCode.ToolDatePart,
        ProductCode.ToolDateAggregate,
        ProductCode.ToolDateFormat
    ],
    [ToolCommandModal.Compute]: [
        ProductCode.ToolAmortization,
        ProductCode.ToolConfusionMatrix,
        ProductCode.ToolMultiFormula,
        ProductCode.ToolLag,
        ProductCode.ToolMinMaxScaler,
        ProductCode.ToolMostCommon,
        ProductCode.ToolOversample,
        ProductCode.ToolRunningAverage,
        ProductCode.ToolRunningTotal,
        ProductCode.ToolSample,
        ProductCode.ToolStandardScaler,
        ProductCode.ToolUndersample,
        ProductCode.ToolWeightedAverage
    ],
    [ToolCommandModal.Understand]: [ProductCode.ToolSegmentation, ProductCode.ToolOutlier],
    [ToolCommandModal.Connect]: [
        ProductCode.ToolData,
        ProductCode.ToolPipe,
        ProductCode.ToolMultiPortPipe,
        ProductCode.ToolExport,
        ProductCode.ToolUSIncome,
        ProductCode.ToolUSPopulation
    ],
    [ToolCommandModal.Encode]: [ProductCode.ToolCategoryEncoder, ProductCode.ToolOneHotEncoder],
    [ToolCommandModal.SampleData]: [ProductCode.ToolSampleCustomers],
    [ToolCommandModal.Optimize]: [ProductCode.ToolAssignmentOptimization],
    [ToolCommandModal.SPM]: [ProductCode.ToolPeriodMapper, ProductCode.ToolRuleMapper],
    [ToolCommandModal.Incentives]: [
        ProductCode.ToolIncentivesExport,
        ProductCode.ToolIncentivesImport,
        ProductCode.ToolIncentivesPeriod,
        ProductCode.ToolIncentivesTable,
        ProductCode.ToolUserDefinedCalc,
        ProductCode.ToolSortCalc,
        ProductCode.ToolTimeShiftCalc,
        ProductCode.ToolCategoryCalc,
        ProductCode.ToolTrueUp,
        ProductCode.ToolExpandPicklist,
        ProductCode.ToolPeriodAdd,
        ProductCode.ToolPeriodDiff,
        ProductCode.ToolPeriodAccumulation
    ],
    [ToolCommandModal.ReusableLogic]: [
        ProductCode.ToolReusableLogicInput,
        ProductCode.ToolReusableLogicOutput,
        ProductCode.ToolReusableLogic
    ],
    [ToolCommandModal.Visualizations]: [
        ProductCode.ToolTable,
        ProductCode.ToolHistogram,
        ProductCode.ToolLine,
        ProductCode.ToolSmoothLine,
        ProductCode.ToolStepLine,
        ProductCode.ToolAreaLine,
        ProductCode.ToolAreaSmoothLine,
        ProductCode.ToolAreaStepLine,
        ProductCode.ToolStackedAreaLine,
        ProductCode.ToolStackedAreaSmoothLine,
        ProductCode.ToolStackedAreaStepLine,
        ProductCode.ToolCombo,
        ProductCode.ToolColumn,
        ProductCode.ToolStackedColumn,
        ProductCode.ToolBar,
        ProductCode.ToolStackedBar,
        ProductCode.ToolPie,
        ProductCode.ToolDoughnut,
        ProductCode.ToolScatter,
        ProductCode.ToolBubble,
        ProductCode.ToolBubbleSingleAxis,
        ProductCode.ToolMap,
        ProductCode.ToolScatterMap,
        ProductCode.ToolWaterfall,
        ProductCode.ToolRadar,
        ProductCode.ToolCandlestick,
        ProductCode.ToolForecasting,
        ProductCode.ToolSankey,
        ProductCode.ToolHeatmap,
        ProductCode.ToolBoxplot,
        ProductCode.ToolNestedPie
    ]
};
export const connectorProductCodeMap = new Map([
    [ConnectionType.Tqp, ProductCode.ConnectorTqp],
    [ConnectionType.Icm, ProductCode.ConnectorIcm]
]);
export const blueprintProductCodeMap = new Map([
    // HowTo's
    [BlueprintType.FuzzyMatcher, ProductCode.BlueprintFuzzyMatcher],
    [BlueprintType.SmartMatcher, ProductCode.BlueprintSmartMatcher],
    [BlueprintType.CombinationMatcher, ProductCode.BlueprintCombinationMatcher],
    [BlueprintType.HierarchyCreation, ProductCode.BlueprintHierarchyCreation],
    [BlueprintType.HierarchyValidator, ProductCode.BlueprintHierarchyValidator],
    [BlueprintType.Forecasting, ProductCode.BlueprintForecasting],
    // ELT
    [BlueprintType.OrderConsolidation, ProductCode.BlueprintOrderConsolidation],
    [BlueprintType.RosterValidation, ProductCode.BlueprintRosterValidation],
    [BlueprintType.RecordAndAdjustment, ProductCode.BlueprintRecordIDAndAdjustment],
    [BlueprintType.IdentifyNewHires, ProductCode.BlueprintIdentifyNewHires],
    [BlueprintType.TrackTerritoryChanges, ProductCode.BlueprintTrackTerritoryChanges],
    [BlueprintType.TransactionReconciliation, ProductCode.BlueprintTransactionReconciliation],
    [BlueprintType.TransactionValidation, ProductCode.BlueprintTransactionValidation],
    [BlueprintType.EntityResolution, ProductCode.BlueprintEntityResolution],
    // Sales Compensation
    [BlueprintType.PayoutOutlier, ProductCode.BlueprintPayoutOutliers],
    [BlueprintType.AdjustmentOutlier, ProductCode.BlueprintManualAdjustmentOutliers],
    [BlueprintType.RevenueVsPayout, ProductCode.BlueprintSellerValueOutliers],
    [BlueprintType.ASC606Amortization, ProductCode.BlueprintASC606Amortization],
    [BlueprintType.ASC606Preparation, ProductCode.BlueprintASC606Preparation],
    [BlueprintType.TransactionOutlier, ProductCode.BlueprintTransactionOutliers],
    // Revenue Intelligence
    [BlueprintType.OpportunityScores, ProductCode.BlueprintOpportunityScores],
    [BlueprintType.DealValueChanges, ProductCode.BlueprintDealValueChanges],
    [BlueprintType.DiscountingDiagnostics, ProductCode.BlueprintDiscountingDiagnostics],
    [BlueprintType.LeadScoring, ProductCode.BlueprintLeadScoring],
    [BlueprintType.CustomerLifetimeValue, ProductCode.BlueprintCustomerLifetimeValue],
    [BlueprintType.SellerCapacity, ProductCode.BlueprintSellerCapacity],
    [BlueprintType.FinancialAdvisorTurnover, ProductCode.BlueprintFinancialAdvisorTurnover]
]);
export const appProductCodeMap = new Map([
    // Marketplace
    [SolutionType.Benchmarking, ProductCode.AppSalesBenchmarking],
    [SolutionType.GenderPayGap, ProductCode.AppGenderPay],
    [SolutionType.Diversity, ProductCode.AppDiversity],
    [SolutionType.Churn, ProductCode.AppCustomerChurn],
    [SolutionType.SellerChurn, ProductCode.AppSellerChurn],
    [SolutionType.SellerPerformance, ProductCode.AppSellerPerformance]
]);
// @ts-ignore
export const toolProductCodeMap = new Map([
    // Predictor
    [ToolType.PREDICT_GENDER, ProductCode.ToolGenderClassifier],
    [ToolType.SMART_MATCHER, ProductCode.ToolSmartMatcher],
    [ToolType.CLASSIFIER, ProductCode.ToolClassifier],
    [ToolType.REGRESSOR, ProductCode.ToolRegressor],
    [ToolType.FORECAST, ProductCode.ToolForecast],
    [ToolType.PREDICTOR, ProductCode.ToolPredictor],
    // Monte Carlo
    [ToolType.MONTE_CARLO, ProductCode.ToolMonteCarlo],
    [ToolType.RANDOM_NUMBER_GENERATOR, ProductCode.ToolRandomNumberGenerator],
    // Group
    [ToolType.AGGREGATE, ProductCode.ToolAggregate],
    [ToolType.AGGREGATEV2, ProductCode.ToolAggregateV2],
    [ToolType.BINNING, ProductCode.ToolBinning],
    [ToolType.QUANTILE, ProductCode.ToolPercentile],
    // Compare
    [ToolType.RANK, ProductCode.ToolRank],
    [ToolType.SORT, ProductCode.ToolSort],
    // Clean
    [ToolType.ADAPT, ProductCode.ToolAdapt],
    [ToolType.CASE, ProductCode.ToolCase],
    [ToolType.CHANGE_TYPE, ProductCode.ToolChangeType],
    [ToolType.CLEAN_CHARACTER, ProductCode.ToolCleanCharacter],
    [ToolType.CONDITIONAL, ProductCode.ToolConditional],
    [ToolType.DISTINCT, ProductCode.ToolUnique],
    [ToolType.DROP, ProductCode.ToolDrop],
    [ToolType.FILL, ProductCode.ToolFill],
    [ToolType.FILTER, ProductCode.ToolFilter],
    [ToolType.LIMIT, ProductCode.ToolLimit],
    [ToolType.REMOVE_OUTLIERS, ProductCode.ToolRemoveOutliers],
    [ToolType.REMOVE_EMPTY, ProductCode.ToolRemoveEmpty],
    [ToolType.RENAME, ProductCode.ToolRename],
    [ToolType.REORDER, ProductCode.ToolReorder],
    [ToolType.SELECT, ProductCode.ToolSelect],
    [ToolType.HIERARCHY_VALIDATOR, ProductCode.ToolHierarchyValidator],
    [ToolType.HIERARCHY_VALIDATORV2, ProductCode.ToolHierarchyValidatorV2],
    // Date
    [ToolType.DATE_ADD, ProductCode.ToolDateAdd],
    [ToolType.DATE_DIFF, ProductCode.ToolDateDiff],
    [ToolType.DATE_PART, ProductCode.ToolDatePart],
    [ToolType.DATE_AGGREGATE, ProductCode.ToolDateAggregate],
    [ToolType.DATE_FORMAT, ProductCode.ToolDateFormat],
    // Compute
    [ToolType.AMORTIZATION, ProductCode.ToolAmortization],
    [ToolType.CONFUSION_MATRIX, ProductCode.ToolConfusionMatrix],
    [ToolType.FORMULA, ProductCode.ToolMultiFormula],
    [ToolType.MULTI_FORMULA, ProductCode.ToolMultiFormula],
    [ToolType.LAG, ProductCode.ToolLag],
    [ToolType.MIN_MAX_SCALER, ProductCode.ToolMinMaxScaler],
    [ToolType.MOST_COMMON, ProductCode.ToolMostCommon],
    [ToolType.OVERSAMPLE, ProductCode.ToolOversample],
    [ToolType.RUNNING_AVERAGE, ProductCode.ToolRunningAverage],
    [ToolType.RUNNING_TOTAL, ProductCode.ToolRunningTotal],
    [ToolType.SAMPLE, ProductCode.ToolSample],
    [ToolType.STANDARD_SCALER, ProductCode.ToolStandardScaler],
    [ToolType.UNDERSAMPLE, ProductCode.ToolUndersample],
    [ToolType.WEIGHTED_AVERAGE, ProductCode.ToolWeightedAverage],
    // Encode
    [ToolType.CATEGORY_ENCODER, ProductCode.ToolCategoryEncoder],
    [ToolType.ONE_HOT_ENCODER, ProductCode.ToolOneHotEncoder],
    // Text
    [ToolType.CHANGE_CASE, ProductCode.ToolChangeCase],
    [ToolType.EXTRACT, ProductCode.ToolExtract],
    [ToolType.MERGE_COLUMNS, ProductCode.ToolMergeColumns],
    [ToolType.REPLACE, ProductCode.ToolReplace],
    [ToolType.MULTI_REPLACE, ProductCode.ToolMultiReplace],
    [ToolType.SELECT_WORD, ProductCode.ToolSelectWord],
    [ToolType.TEXT_BETWEEN, ProductCode.ToolTextBetween],
    [ToolType.TEXT_LENGTH, ProductCode.ToolTextLength],
    [ToolType.TEXT_PART, ProductCode.ToolTextPart],
    [ToolType.TEXT_SENTIMENT, ProductCode.ToolTextSentiment],
    [ToolType.TRIM, ProductCode.ToolTrim],
    [ToolType.TRIM_TAGS, ProductCode.ToolTrimTags],
    [ToolType.TEXT_CLASSIFIER, ProductCode.ToolTextClassifier],
    [ToolType.WORD_FREQUENCY, ProductCode.ToolWordFrequency],
    // Prepare
    [ToolType.COMBINATION_MATCHER, ProductCode.ToolCombinationMatcher],
    [ToolType.FUZZY_MATCHER, ProductCode.ToolFuzzyMatcher],
    [ToolType.JOIN, ProductCode.ToolJoin],
    [ToolType.RECORD_ID, ProductCode.ToolRecordID],
    [ToolType.REPEAT, ProductCode.ToolRepeat],
    [ToolType.RESHAPE, ProductCode.ToolReshape],
    [ToolType.SNAPSHOT, ProductCode.ToolSnapshot],
    [ToolType.SPLIT, ProductCode.ToolSplit],
    [ToolType.TEXT_GRADE_LEVEL, ProductCode.ToolTextGradeLevel],
    [ToolType.UNION, ProductCode.ToolUnion],
    [ToolType.MULTI_UNION, ProductCode.ToolMultiUnion],
    [ToolType.HIERARCHY, ProductCode.ToolHierarchy],
    [ToolType.HIERARCHYV2, ProductCode.ToolHierarchyV2],
    [ToolType.LOOKUP, ProductCode.ToolLookup],
    // Understand
    [ToolType.SEGMENTATION, ProductCode.ToolSegmentation],
    [ToolType.OUTLIER, ProductCode.ToolOutlier],
    // Connect
    [ToolType.FILE, ProductCode.ToolData],
    [ToolType.PIPE, ProductCode.ToolPipe],
    [ToolType.MULTI_PORT_PIPE, ProductCode.ToolMultiPortPipe],
    [ToolType.EXPORT, ProductCode.ToolExport],
    [ToolType.US_INCOME, ProductCode.ToolUSIncome],
    [ToolType.US_POPULATION, ProductCode.ToolUSPopulation],
    // Optimization
    [ToolType.ASSIGNMENT_OPTIMIZATION, ProductCode.ToolAssignmentOptimization],
    // Sample data
    [ToolType.SAMPLE_CUSTOMERS, ProductCode.ToolSampleCustomers],
    // SPM
    [ToolType.PERIOD_MAPPER, ProductCode.ToolPeriodMapper],
    [ToolType.RULE_MAPPER, ProductCode.ToolRuleMapper],
    // Incentives
    [ToolType.INCENTIVES_EXPORT, ProductCode.ToolIncentivesExport],
    [ToolType.INCENTIVES_IMPORT, ProductCode.ToolIncentivesImport],
    [ToolType.INCENTIVES_TABLE, ProductCode.ToolIncentivesTable],
    [ToolType.INCENTIVES_PERIOD, ProductCode.ToolIncentivesPeriod],
    [ToolType.USER_DEFINED_CALC, ProductCode.ToolUserDefinedCalc],
    [ToolType.SORT_CALC, ProductCode.ToolSortCalc],
    [ToolType.TIME_SHIFT_CALC, ProductCode.ToolTimeShiftCalc],
    [ToolType.CATEGORY_CALC, ProductCode.ToolCategoryCalc],
    [ToolType.TRUE_UP, ProductCode.ToolTrueUp],
    [ToolType.PERIOD_ADD, ProductCode.ToolPeriodAdd],
    [ToolType.PERIOD_DIFF, ProductCode.ToolPeriodDiff],
    [ToolType.EXPAND_PICKLIST, ProductCode.ToolExpandPicklist],
    [ToolType.PERIOD_ACCUMULATION, ProductCode.ToolPeriodAccumulation],
    // Reusable Logic
    [ToolType.REUSABLE_LOGIC_INPUT, ProductCode.ToolReusableLogicInput],
    [ToolType.REUSABLE_LOGIC_OUTPUT, ProductCode.ToolReusableLogicOutput],
    [ToolType.REUSABLE_LOGIC, ProductCode.ToolReusableLogic]
]);
export const visualizationProductCodeMap = new Map([
    [VisualType.Table, ProductCode.ToolTable],
    [VisualType.Histogram, ProductCode.ToolHistogram],
    [GenericVisualSubType.Line, ProductCode.ToolLine],
    [GenericVisualSubType.SmoothLine, ProductCode.ToolSmoothLine],
    [GenericVisualSubType.StepLine, ProductCode.ToolStepLine],
    [GenericVisualSubType.AreaLine, ProductCode.ToolAreaLine],
    [GenericVisualSubType.AreaSmoothLine, ProductCode.ToolAreaSmoothLine],
    [GenericVisualSubType.AreaStepLine, ProductCode.ToolAreaStepLine],
    [GenericVisualSubType.AreaLineStacked, ProductCode.ToolStackedAreaLine],
    [GenericVisualSubType.AreaSmoothLineStacked, ProductCode.ToolStackedAreaSmoothLine],
    [GenericVisualSubType.AreaStepLineStacked, ProductCode.ToolStackedAreaStepLine],
    [VisualType.Combination, ProductCode.ToolCombo],
    [GenericVisualSubType.Column, ProductCode.ToolColumn],
    [GenericVisualSubType.ColumnStacked, ProductCode.ToolStackedColumn],
    [GenericVisualSubType.Bar, ProductCode.ToolBar],
    [GenericVisualSubType.BarStacked, ProductCode.ToolStackedBar],
    [CircleVisualSubType.Pie, ProductCode.ToolPie],
    [CircleVisualSubType.Doughnut, ProductCode.ToolDoughnut],
    [GenericVisualSubType.Scatter, ProductCode.ToolScatter],
    [VisualType.Bubble, ProductCode.ToolBubble],
    [VisualType.BubbleSingleAxis, ProductCode.ToolBubbleSingleAxis],
    [VisualType.Map, ProductCode.ToolMap],
    [VisualType.ScatterMap, ProductCode.ToolScatterMap],
    [GenericVisualSubType.Waterfall, ProductCode.ToolWaterfall],
    [GenericVisualSubType.Radar, ProductCode.ToolRadar],
    [VisualType.Candlestick, ProductCode.ToolCandlestick],
    [VisualType.Forecast, ProductCode.ToolForecasting],
    [VisualType.Sankey, ProductCode.ToolSankey],
    [VisualType.Heatmap, ProductCode.ToolHeatmap],
    [VisualType.Boxplot, ProductCode.ToolBoxplot],
    [CircleVisualSubType.Nested, ProductCode.ToolNestedPie]
]);
export const SubscriptionProductCodeMap = {
    [SubscriptionType.PLG]: [
        // Tools
        ...ToolsGroup[ToolCommandModal.Predictor],
        ...ToolsGroup[ToolCommandModal.Prepare],
        ...ToolsGroup[ToolCommandModal.Group],
        ...ToolsGroup[ToolCommandModal.Compare],
        ...ToolsGroup[ToolCommandModal.Clean],
        ...ToolsGroup[ToolCommandModal.Text],
        ...ToolsGroup[ToolCommandModal.Date],
        ...ToolsGroup[ToolCommandModal.Compute],
        ...ToolsGroup[ToolCommandModal.Understand],
        ...ToolsGroup[ToolCommandModal.Connect],
        ...ToolsGroup[ToolCommandModal.Encode],
        ...ToolsGroup[ToolCommandModal.SampleData],
        ...ToolsGroup[ToolCommandModal.Optimize],
        ...ToolsGroup[ToolCommandModal.Visualizations],
        ...ToolsGroup[ToolCommandModal.ReusableLogic],
        ...BlueprintsGroup.blueprintsHowTos,
        ProductCode.AppSalesBenchmarking,
        ProductCode.AppGenderPay,
        ProductCode.AppDiversity,
        ProductCode.AppCustomerChurn
    ],
    [SubscriptionType.VaricentAdvantageAnalytics]: [
        // Blueprints and Apps
        ...BlueprintsGroup[BlueprintModelType.Marketplace],
        ...BlueprintsGroup[BlueprintModelType.SalesCompensation],
        ProductCode.AppGenderPay,
        ProductCode.AppDiversity,
        ProductCode.AppCustomerChurn,
        // Tools
        ...ToolsGroup[ToolCommandModal.Group],
        ...ToolsGroup[ToolCommandModal.Compare],
        ProductCode.ToolDrop,
        ProductCode.ToolFilter,
        ProductCode.ToolAmortization,
        ProductCode.ToolData,
        ProductCode.ToolPipe,
        ProductCode.ToolExport,
        ...ToolsGroup[ToolCommandModal.SampleData],
        ...ToolsGroup[ToolCommandModal.Visualizations],
        // Connectors
        ProductCode.ConnectorIcm
    ],
    [SubscriptionType.VaricentELT]: [
        // Blueprints and Apps
        ProductCode.BlueprintFuzzyMatcher,
        ProductCode.BlueprintSmartMatcher,
        ProductCode.BlueprintCombinationMatcher,
        ProductCode.BlueprintHierarchyCreation,
        ProductCode.BlueprintHierarchyValidator,
        ...BlueprintsGroup[BlueprintModelType.Marketplace],
        ...BlueprintsGroup[BlueprintModelType.ELT],
        ...BlueprintsGroup[BlueprintModelType.SalesCompensation],
        ProductCode.AppGenderPay,
        ProductCode.AppDiversity,
        ProductCode.AppCustomerChurn,
        // Tools
        ProductCode.ToolSmartMatcher,
        ...ToolsGroup[ToolCommandModal.Prepare],
        ...ToolsGroup[ToolCommandModal.Group],
        ...ToolsGroup[ToolCommandModal.Compare],
        ...ToolsGroup[ToolCommandModal.Clean],
        ...ToolsGroup[ToolCommandModal.Text],
        ...ToolsGroup[ToolCommandModal.Date],
        ...ToolsGroup[ToolCommandModal.Compute],
        ...ToolsGroup[ToolCommandModal.Connect],
        ...ToolsGroup[ToolCommandModal.Encode],
        ...ToolsGroup[ToolCommandModal.SampleData],
        ...ToolsGroup[ToolCommandModal.SPM],
        ...ToolsGroup[ToolCommandModal.Visualizations],
        ...ToolsGroup[ToolCommandModal.ReusableLogic],
        // Connectors
        ProductCode.ConnectorIcm,
        ProductCode.ConnectorTqp
    ],
    [SubscriptionType.VaricentAI]: [
        // Blueprints and Apps
        ...BlueprintsGroup[BlueprintModelType.HowTos],
        ...BlueprintsGroup[BlueprintModelType.Marketplace],
        ...BlueprintsGroup[BlueprintModelType.ELT],
        ...BlueprintsGroup[BlueprintModelType.RevIntel],
        ...BlueprintsGroup[BlueprintModelType.SalesCompensation],
        ProductCode.AppGenderPay,
        ProductCode.AppDiversity,
        ProductCode.AppCustomerChurn,
        ProductCode.ToolMonteCarlo,
        ProductCode.ToolRandomNumberGenerator,
        // Tools
        ...ToolsGroup[ToolCommandModal.Predictor],
        ...ToolsGroup[ToolCommandModal.Prepare],
        ...ToolsGroup[ToolCommandModal.Group],
        ...ToolsGroup[ToolCommandModal.Compare],
        ...ToolsGroup[ToolCommandModal.Clean],
        ...ToolsGroup[ToolCommandModal.Text],
        ...ToolsGroup[ToolCommandModal.Date],
        ...ToolsGroup[ToolCommandModal.Compute],
        ...ToolsGroup[ToolCommandModal.Understand],
        ...ToolsGroup[ToolCommandModal.Connect],
        ...ToolsGroup[ToolCommandModal.Encode],
        ...ToolsGroup[ToolCommandModal.SampleData],
        ...ToolsGroup[ToolCommandModal.Optimize],
        ...ToolsGroup[ToolCommandModal.SPM],
        ...ToolsGroup[ToolCommandModal.Visualizations],
        ...ToolsGroup[ToolCommandModal.ReusableLogic],
        // Connectors
        ProductCode.ConnectorIcm,
        ProductCode.ConnectorTqp
    ],
    [SubscriptionType.VaricentSalesPlanning]: [
        // Blueprints and Apps
        ...BlueprintsGroup[BlueprintModelType.HowTos],
        ...BlueprintsGroup[BlueprintModelType.Marketplace],
        // Tools
        ProductCode.ToolRegressor,
        ...ToolsGroup[ToolCommandModal.Prepare],
        ...ToolsGroup[ToolCommandModal.Group],
        ...ToolsGroup[ToolCommandModal.Compare],
        ...ToolsGroup[ToolCommandModal.Clean],
        ...ToolsGroup[ToolCommandModal.Text],
        ...ToolsGroup[ToolCommandModal.Date],
        ...ToolsGroup[ToolCommandModal.Compute],
        ...ToolsGroup[ToolCommandModal.Understand],
        ...ToolsGroup[ToolCommandModal.Connect],
        ...ToolsGroup[ToolCommandModal.Encode],
        ...ToolsGroup[ToolCommandModal.SampleData],
        ...ToolsGroup[ToolCommandModal.Optimize],
        ...ToolsGroup[ToolCommandModal.SPM],
        ...ToolsGroup[ToolCommandModal.Visualizations],
        ...ToolsGroup[ToolCommandModal.ReusableLogic],
        // Connectors
        ProductCode.ConnectorIcm,
        ProductCode.ConnectorTqp
    ],
    [SubscriptionType.VaricentDesigner]: [
        // Prepare
        ProductCode.ToolJoin,
        ProductCode.ToolReshape,
        ProductCode.ToolUnion,
        ProductCode.ToolMultiUnion,
        // Group
        ProductCode.ToolAggregate,
        ProductCode.ToolAggregateV2,
        // Compare
        ProductCode.ToolSort,
        // Clean
        ProductCode.ToolCase,
        ProductCode.ToolChangeType,
        ProductCode.ToolFilter,
        ProductCode.ToolRename,
        ProductCode.ToolSelect,
        // Text
        ProductCode.ToolMergeColumns,
        // Compute
        ProductCode.ToolMultiFormula,
        ProductCode.ToolRunningTotal,
        // SPM
        ProductCode.ToolRuleMapper,
        ...ToolsGroup[ToolCommandModal.Date],
        ...ToolsGroup[ToolCommandModal.Incentives],
        ...ToolsGroup[ToolCommandModal.ReusableLogic]
    ]
};
//# sourceMappingURL=subscriptionType.js.map